import React from "react";
import clsx from "clsx/lite";

const Skeleton = ({
	amount = 1,
	width = "w-full",
	height = "h-4",
	rounded = "rounded-md",
	className = "",
}) => {
	return (
		<div role="status" aria-busy="true" aria-live="polite">
			{Array.from({ length: amount }).map((_, i) => (
				<div
					key={i}
					className={clsx(
						"bg-gray-200 animate-pulse my-2",
						width,
						height,
						rounded,
						className
					)}
				/>
			))}
		</div>
	);
};

export default Skeleton;
